module.exports = __webpack_public_path__ + "static/media/Lidovci-pouť96-10.dbdd2779.jpg";